import {AreaFragmentDto, FaceDto, SectionFragmentType} from "@hec/api-dtos";

export const GetAreaFragmentsFromFace = (face: FaceDto): AreaFragmentDto[] => {
  const result = face.sectionFragments.filter(x=> x.sectionFragmentType === SectionFragmentType.AreaFragment) ?? [];
  return result as AreaFragmentDto[];
}
